// src/pages/inquiries/UserSaleSubmission.tsx
import React, {useState, CSSProperties } from 'react';
import {collection, addDoc } from 'firebase/firestore';
import {ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import {db, storage } from '../../firebase';

const styles: {[key: string]: CSSProperties } = {
  container: {
    padding: '2rem',
    maxWidth: '800px',
    margin: 'auto',
    fontFamily: 'Arial, sans-serif',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  input: {
    padding: '0.75rem',
    borderRadius: '4px',
    border: '1px solid #ccc',
  },
  textarea: {
    padding: '0.75rem',
    borderRadius: '4px',
    border: '1px solid #ccc',
    minHeight: '100px',
  },
  select: {
    padding: '0.75rem',
    borderRadius: '4px',
    border: '1px solid #ccc',
  },
  button: {
    padding: '0.75rem',
    backgroundColor: '#007BFF',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
  },
  status: {
    marginTop: '1rem',
    padding: '0.75rem',
    borderRadius: '4px',
    textAlign: 'center',
  },
  success: {
    backgroundColor: '#d4edda',
    color: '#155724',
  },
  error: {
    backgroundColor: '#f8d7da',
    color: '#721c24',
  },
};

const UserSaleSubmission = () => {
  const [itemName, setItemName] = useState('');
  const [description, setDescription] = useState('');
  const [category, setCategory] = useState('');
  const [proposedPrice, setProposedPrice] = useState('');
  const [contactInfo, setContactInfo] = useState('');
  const [images, setImages] = useState<FileList | null>(null);
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setImages(e.target.files);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setStatus('');

    try {
      const imageUrls: string[] = [];
      if (images) {
        for (let i = 0; i < images.length; i++) {
          const image = images[i];
          const storageRef = ref(storage, `sale_items/${Date.now()}_${image.name}`);
          const snapshot = await uploadBytes(storageRef, image);
          const downloadURL = await getDownloadURL(snapshot.ref);
          imageUrls.push(downloadURL);
        }
      }

      const submissionData = {
        itemName,
        description,
        category,
        proposedPrice: parseFloat(proposedPrice),
        contactInfo,
        imageUrls,
        status: 'Pending',
        submittedAt: new Date(),
      };

      await addDoc(collection(db, 'saleSubmissions'), submissionData);
      setStatus('Your item has been submitted successfully! We will contact you soon. ✅');
      
      // Reset form
      setItemName('');
      setDescription('');
      setCategory('');
      setProposedPrice('');
      setContactInfo('');
      setImages(null);

    } catch (error) {
      console.error('Error submitting form:', error);
      setStatus('An error occurred. Please try again. ❌');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <h2>Submit an Item to GREMA Administration</h2>
      <p>Fill out the form below to present your item for GREMA administration to sell.</p>
      <form onSubmit={handleSubmit} style={styles.form}>
        <input
          type="text"
          placeholder="Item Name"
          value={itemName}
          onChange={(e) => setItemName(e.target.value)}
          style={styles.input}
          required
        />
        <textarea
          placeholder="Detailed Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          style={styles.textarea}
          required
        />
        <select value={category} onChange={(e) => setCategory(e.target.value)} style={styles.select} required>
          <option value="" disabled>Select Category</option>
          <option value="Real Estate">Real Estate</option>
          <option value="Stalls">Stalls</option>
          <option value="Vehicles">Vehicles</option>
          <option value="Other">Other</option>
        </select>
        <input
          type="number"
          placeholder="Proposed Price"
          value={proposedPrice}
          onChange={(e) => setProposedPrice(e.target.value)}
          style={styles.input}
          required
        />
        <input
          type="text"
          placeholder="Your Contact Info (e.g., Email or Phone)"
          value={contactInfo}
          onChange={(e) => setContactInfo(e.target.value)}
          style={styles.input}
          required
        />
        <div>
          <label>Item Images: </label>
          <input
            type="file"
            multiple
            accept="image/*"
            onChange={handleImageChange}
          />
        </div>
        <button type="submit" style={styles.button} disabled={loading}>
          {loading ? 'Submitting...' : 'Submit Item'}
        </button>
      </form>
      {status && <p style={status.includes('✅') ? {...styles.status, ...styles.success } : {...styles.status, ...styles.error }}>{status}</p>}
    </div>
  );
};

export default UserSaleSubmission;